<div *adaptIfAuthorised="EditObjectives"
     class="d-none d-md-flex flex-column align-items-center my-4 overflow-hidden">
    <button class="btn btn-primary px-4"
            (click)="runTour()">Tour the objectives</button>
</div>

<div class="d-flex d-md-none flex-column align-items-center my-4 overflow-hidden">
    <p>Sorry, you cannot start this tour on mobile devices. Please use a desktop device, or switch to desktop mode.</p>
</div>
